import { takeEvery, put } from "redux-saga/effects";

import axios from "axios";

import gradeType from "./gradeType";
import { gradeCategoriesApi } from "../../../utility/api/apiList";
import { successFetchedGrade } from "./gradeActions";


export function* startfetchingGrade (action) {
    const response =yield axios.get(gradeCategoriesApi)
    const handle = yield put(successFetchedGrade(response.data))
}


export function* fetchGrade (){
yield takeEvery(gradeType.START_FETCHING_GRADE,startfetchingGrade )
}
